import { ChangeEvent, FC } from 'react'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'
import { Button, Input } from 'antd'
import { EditOutlined } from '@ant-design/icons'

import {
  DEFAULT_PROJECT_NAME,
} from '@/constants/tools/solid-background-video'
import { poppins } from '@/components/common/fonts'
import { MAX_PROJECT_NAME_LENGTH } from '@/constants/project'

export const Menu: FC<{
  projectName: string
  onChangeProjectName: (projectName: string) => void

  onGoToAdvancedEditor: () => void

  onDownload: () => void
  disabledDownload: boolean

  isLoading: boolean
  isDownloading: boolean
}> = ({
  projectName,
  onChangeProjectName,

  onGoToAdvancedEditor,

  onDownload,
  disabledDownload,

  isLoading,
  isDownloading,
}) => {
  const { t } = useTranslation('common')

  const handleChangeProjectName = (e: ChangeEvent<HTMLInputElement>) => {
    const inputtedProjectName = e.target.value

    const trimmedProjectName = inputtedProjectName.trim()

    if (trimmedProjectName.length > MAX_PROJECT_NAME_LENGTH) {
      return
    }

    onChangeProjectName(inputtedProjectName)
  }
  const handleBlurProjectName = () => {
    const trimmedProjectName = projectName.trim()

    onChangeProjectName(trimmedProjectName)
  }

  return (
    <MenuContainer>
      <ProjectNameInput
        value={projectName}
        onChange={handleChangeProjectName}
        onBlur={handleBlurProjectName}
        placeholder={DEFAULT_PROJECT_NAME}
        prefix={<EditOutlined width={20} height={20} />}
        title={projectName}
      />
      <AdvancedEditorButton onClick={onGoToAdvancedEditor} loading={isLoading}>
        {t('Advanced Editor')}
      </AdvancedEditorButton>

      <DownloadButton
        type="primary"
        onClick={onDownload}
        disabled={disabledDownload}
        loading={isLoading || isDownloading}
      >
        {t('Download')}
      </DownloadButton>
    </MenuContainer>
  )
}

const MenuContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  height: 40px;
`

const ProjectNameInput = styled(Input)`
  height: 100%;
  width: 180px;
  padding-inline: 12px;

  &&& input {
    font-family: ${poppins.string};
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;

    text-overflow: ellipsis;
  }
`

const AdvancedEditorButton = styled(Button)`
  height: 100%;
  padding-inline: 12px;

  font-family: ${poppins.string};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #12102d;
`

const DownloadButton = styled(Button)`
  height: 100%;
  padding-inline: 12px;

  background-color: #146ef5;

  font-family: ${poppins.string};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`
